"use client";

import React from "react";
import dynamic from "next/dynamic";
const Button = dynamic(() => import("@/Components/Button"),{ssr: true});

type PaymentData = {
  payment?: {
    id?: string;
    create_time?: string;
    transactions?: {
      amount?: {
        total?: string;
        currency?: string;
      };
    }[];
  };
};

type RightFormProps = {
  data?: PaymentData;
  error?: string | null;
};

const RightForm: React.FC<RightFormProps> = ({ data, error }) => {
  return (
    <div className="bg-[url(/images/Quote-bg.webp)]  bg-no-repeat bg-cover bg-center h-full w-full">
      <div className="p-[48px_24px] lg:p-[48px_24px] xl:p-[48px_48px] h-full items-stretch">
        <div className="global-right-content h-full">
          <div className="w-full p-5 bg-white h-full mb-5 shadow-sm">
            <div className="p-2">
              {error !== null ? (
                // Payment Failed
                <div className="flex flex-col items-center justify-center mt-5">
                  <div className="flex justify-center mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 100"
                      width="100"
                      height="100"
                    >
                      <circle
                        cx="50"
                        cy="50"
                        r="48"
                        stroke="#f44336"
                        strokeWidth="4"
                        fill="none"
                      />
                      <path
                        d="M30,30 L70,70 M70,30 L30,70"
                        stroke="#f44336"
                        strokeWidth="5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  <h2 className="mb-12 text-xl font-semibold">
                    Something went wrong
                  </h2>
                  <p className="mb-2 text-center text-gray-600">
                    We&apos;re sorry, but something went wrong while processing
                    your payment. Please try again later.
                  </p>
                  <div className="text-center mt-6">
                    <button
                      className="bg-green-600 hover:bg-green-700 text-white px-5 py-2 rounded-md text-base font-medium"
                      onClick={() => (window.location.href = "/")}
                    >
                      Go Back to Home
                    </button>
                  </div>
                </div>
              ) : (
                // Payment Success
                <>
                  {/* Success Icon */}
                  <div className="flex justify-center mb-4">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 100 100"
                      width="100"
                      height="100"
                    >
                      <circle
                        cx="50"
                        cy="50"
                        r="48"
                        stroke="#4CAF50"
                        strokeWidth="4"
                        fill="none"
                      />
                      <path
                        d="M20,50 L40,70 L80,30"
                        stroke="#4CAF50"
                        strokeWidth="5"
                        fill="none"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>

                  {/* Payment Success Title */}
                  <h2 className="text-center text-green-600 text-2xl font-semibold mb-10">
                    Payment Successful!
                  </h2>

                  {/* Payment Information */}
                  <p className="text-gray-800 text-base mb-2">
                    Transaction ID: <strong>{data?.payment?.id}</strong>
                  </p>
                  <p className="text-gray-800 text-base mb-2">
                    Date:{" "}
                    <strong>
                      {data?.payment?.create_time
                        ?.replaceAll("T", " ")
                        .replaceAll("Z", " ")}
                    </strong>
                  </p>

                  {/* Payment Details */}
                  <div className="mb-4 mt-[20px]">
                    <strong className="block mb-2">Payment Details</strong>
                    <ul className="mb-2 list-none">
                      <li className="mb-2">
                        Total Amount:{" "}
                        <strong>
                          {data?.payment?.transactions?.[0]?.amount?.total}{" "}
                          {data?.payment?.transactions?.[0]?.amount?.currency}
                        </strong>
                      </li>
                    </ul>
                  </div>

                  {/* Go Back Button */}
                  <div className="text-center mt-6">
                    <Button
                      label={"Go Back to Home"}
                      type="button"
                      variant="small"
                      onClick={() => (window.location.href = "/")}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RightForm;
